module.exports = __webpack_public_path__ + "static/activityIcon1.51551569.png";